import React from 'react';
import './Techniques.css';

function Techniques() {
  const techniquesData = [
    {
      id: 1,
      title: "Tersine Mühendislik",
      description: "Soruyu sadece çözüp geçmiyoruz. ÖSYM'nin soruyu nasıl hazırladığını ve çeldiricileri nasıl kurguladığını analiz ediyoruz.",
      number: "01"
    },
    {
      id: 2,
      title: "Mikro Hedefleme",
      description: "Öğrenciyi devasa konu yığınlarıyla boğmuyor, konuları küçük ve sindirilebilir parçalara bölerek işliyoruz.",
      number: "02"
    },
    {
      id: 3,
      title: "Simülasyon Çözümleri",
      description: "Klasik test kitapları yerine, son 10 yılın çıkmış sorularını güncel formata uyarlayarak gerçek sınav provası yapıyoruz.",
      number: "03"
    },
    {
      id: 4,
      title: "Hata Analiz Günlüğü",
      description: "Öğrencinin yanlış yaptığı soruları özel bir havuzda biriktiriyor ve sınavdan önce 'Kişisel Hata Tekrarı' yapıyoruz.",
      number: "04"
    }
  ];

  return (
    <section className="techniques-section" id="teknikler">
      <div className="techniques-header">
        <span className="section-subtitle-gold">FARKIMIZ NE?</span>
        <h2>Yeni Nesil Eğitim <span className="text-white">Tekniklerimiz</span></h2>
        <p>Klasik ezberci yöntemleri unutun. Başarıyı şansa bırakmayan, tamamen analitik ve stratejik çalışma modelimiz.</p>
      </div>

      <div className="techniques-grid">
        {techniquesData.map((tech) => (
          <div className="tech-card" key={tech.id}>
            <div className="tech-card-inner">
              <span className="tech-number">{tech.number}</span>
              <h3>{tech.title}</h3>
              <p>{tech.description}</p>
              <div className="tech-hover-line"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Techniques;